import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from '@stripe/react-stripe-js';
import { Div, P } from '@vgrubs/components';
import { INPUT_OPTIONS, StripeInputStyled } from './VDrive.styled';

type Props = {
  /**
   * The card holder name, under the number. Stripe takes it with the card
   * (`createToken`); our backend's body has no field for it. Left out, the
   * form has no name field.
   */
  name?: string;
  onNameChange?: (name: string) => void;
};

export const PaymentCreditCard = ({ name, onNameChange }: Props = {}) => {
  return (
    <div>
      <Div $mb="32">
        <Div $mb="20">
          <P $mb="10">
            <b>Card Number</b>
          </P>
          <StripeInputStyled>
            <CardNumberElement options={INPUT_OPTIONS} />
          </StripeInputStyled>
        </Div>
        {onNameChange && (
          <Div $mb="20">
            <P $mb="10">
              <b>Card Holder Name</b>
            </P>
            <StripeInputStyled>
              <input
                value={name ?? ''}
                onChange={(event) => onNameChange(event.target.value)}
                placeholder="Full Name"
                autoComplete="cc-name"
                aria-label="Card holder name"
              />
            </StripeInputStyled>
          </Div>
        )}
        <Div $flex $gap="1.6rem">
          <Div $width="50%">
            <P $mb="10">
              <b>Exp date</b>
            </P>
            <StripeInputStyled>
              <CardExpiryElement options={INPUT_OPTIONS} />
            </StripeInputStyled>
          </Div>
          <Div $width="50%">
            <P $mb="10">
              <b>CVC</b>
            </P>
            <StripeInputStyled>
              <CardCvcElement options={INPUT_OPTIONS} />
            </StripeInputStyled>
          </Div>
        </Div>
      </Div>
    </div>
  );
};
